import { PopoverPosition as BlueprintPopoverPosition } from '@blueprintjs/core';
import { ArrowLeft } from '@carbon/icons-react';
import * as React from 'react';
import {
  OutlinedIconButton,
  Tooltip,
} from 'vet-bones/design-system/components';

import { ROUTE } from 'src/constants/routes';
import { TEST_IDS } from 'src/constants/testIds';
import { ProjectNavbarActions } from 'src/containers/ProjectNavbar/ProjectNavbarActions';
import { ProjectNavbarSaveState } from 'src/containers/ProjectNavbar/ProjectNavbarSaveState';
import { ProjectNavbarTabs } from 'src/containers/ProjectNavbar/ProjectNavbarTabs';
import { ProjectNavbarTitle } from 'src/containers/ProjectNavbar/ProjectNavbarTitle';
import * as copy from 'src/templates/copy';
import { useNavigate } from 'src/utils/hooks/useNavigate';

import styles from 'src/containers/ProjectNavbar/projectNavbar.module.scss';

export const ProjectNavbar: React.VFC = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.projectNavbar}>
      <div className={styles.projectNavbarLeft}>
        <Tooltip
          description={copy.components.project.navbar.back}
          position={BlueprintPopoverPosition.BOTTOM}
        >
          <OutlinedIconButton
            elevated
            leftIcon={ArrowLeft}
            onClick={() => navigate(ROUTE.HOME)}
            testId={TEST_IDS.projectNavbar.back}
          />
        </Tooltip>
        <ProjectNavbarTitle />
        <ProjectNavbarSaveState />
      </div>

      <div className={styles.projectNavbarCenter}>
        <ProjectNavbarTabs />
      </div>

      <div className={styles.projectNavbarRight}>
        <ProjectNavbarActions />
      </div>
    </div>
  );
};
